import config from 'src/shared/config';
import { getMobileDownloadOptions } from 'src/shared/utils/sessionStorageManager';

const mobileDownloadOptions = getMobileDownloadOptions();

// app-landing.html 에 서 사용, backup용 코드
const openMobileApp = (
  appScheme: string,
  fallbackUrl: string,
  downloadUrl: string,
  packageName: string
): void => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(userAgent);
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isChrome = /chrome/.test(userAgent);
  const isSafari = /safari/.test(userAgent) && !isChrome;
  // const isFirefox = /firefox/.test(userAgent);

  const openApp = (): void => {
    const now = Date.now();
    setTimeout(() => {
      if (Date.now() - now < 3000) {
        window.location.href = fallbackUrl;
      }
    }, 2500);

    // window.open(appScheme, '_blank');
    window.location.href = appScheme;
  };

  if (isAndroid) {
    if (isChrome && parseInt(userAgent.match(/chrome\/(\d+)/)?.[1] || '0', 10) >= 25) {
      const appLink = [
        `intent://open/url=${downloadUrl}#Intent`,
        `scheme=${appScheme.split(':')[0]}`,
        `package=${packageName}`,
        `S.browser_fallback_url=${fallbackUrl}`,
        'end',
      ].join(';');

      // window.open(appLink, '_blank');
      window.location.href = appLink;
    } else {
      openApp();
    }
  } else if (isIOS) {
    const iOSVersion = parseInt((userAgent.match(/os (\d+)/) || [])[1], 10);
    if (isSafari && iOSVersion >= 9) {
      // window.open(appScheme, '_blank');
      window.location.href = appScheme;
    } else {
      openApp();
    }
  } else {
    console.log('This app is only supported on Android and iOS devices.');
  }
};

const openMobileAppLanginPage = (
  appScheme: string,
  fallbackUrl: string,
  downloadUrl: string,
  packageName: string
): void => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isAndroid = /android/.test(userAgent);
  const isIOS = /iphone|ipad|ipod/.test(userAgent);

  if (isAndroid || isIOS) {
    const searchParamStr = [
      `appScheme=${appScheme}`,
      `fallbackUrl=${fallbackUrl}`,
      `downloadUrl=${downloadUrl}`,
      `packageName=${packageName}`,
    ].join('&');
    const aTag = document.createElement('a');
    aTag.href = config.url(`/app-landing.html?${searchParamStr}`);
    aTag.target = '_blank';
    document.body.appendChild(aTag);
    aTag.click();
    document.body.removeChild(aTag);
    // window.open(config.url(`/app-landing.html?${searchParamStr}`), '_blank');
  } else {
    console.log('This app is only supported on Android and iOS devices.');
  }
};

export function openMobileViewer(downloadUrl: string, lang: 'ko' | 'en'): void {
  // 함수 사용 예시
  if (mobileDownloadOptions.useDownload) {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    if (mobileDownloadOptions.downloadAppType === 'fasooview') {
      const appScheme = `fasooview://open/url=${downloadUrl}`;
      const packageName = 'com.fasoo.m.drmviewer';
      const fallbackUrl = isAndroid
        ? `https://play.google.com/store/apps/details?id=${packageName}`
        : isIOS
        ? `https://apps.apple.com/${lang === 'ko' ? 'kr' : 'us'}/app/fasoo-view/id444651561`
        : 'about:blank';
      openMobileAppLanginPage(appScheme, fallbackUrl, downloadUrl, packageName);
    } else if (mobileDownloadOptions.downloadAppType === 'fasooviewplus') {
      const appScheme = `fasooviewplus://open/url=${downloadUrl}`;
      const packageName = 'com.fasoo.m.fasooviewplus';
      const fallbackUrl = isAndroid
        ? `https://play.google.com/store/apps/details?id=${packageName}`
        : isIOS
        ? `https://apps.apple.com/${lang === 'ko' ? 'kr' : 'us'}/app/fasoo-view-plus/id616630101`
        : 'about:blank';
      openMobileAppLanginPage(appScheme, fallbackUrl, downloadUrl, packageName);
    } else {
      const appScheme = `fasoosecureviewer://open/url=${downloadUrl}`;
      const packageName = 'com.fasoo.m.fasoosecureviewer';
      const fallbackUrl = isAndroid
        ? `https://play.google.com/store/apps/details?id=${packageName}`
        : isIOS
        ? `https://apps.apple.com/${
            lang === 'ko' ? 'kr' : 'us'
          }/app/fasoo-secure-viewer/id6478472132`
        : 'about:blank';
      openMobileAppLanginPage(appScheme, fallbackUrl, downloadUrl, packageName);
    }
  }
  return;
}
